<template>
  <div class="c-empty">
    <img class="c-empty-img" :src="emptyImg" alt="" />
    <div class="c-empty-text">
      <slot>{{ text }}</slot>
    </div>
  </div>
</template>
<script>
import imgEmptyCry from '@/assets/images/empty-emote-cry@2x.png';
import imgEmptyError from '@/assets/images/empty-emote-error@2x.png';
import imgEmptyHeartCrack from '@/assets/images/empty-heart-crack@2x.png';
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    text: {
      type: String,
    },
  },
  components: {},
  data() {
    return {
      images: { default: '', cry: imgEmptyCry, error: imgEmptyError, heartCrack: imgEmptyHeartCrack },
    };
  },
  computed: {
    emptyImg() {
      return this.images[this.type];
    },
  },
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  &-img {
    width: 136px;
  }
  &-text {
    display: flex;
    flex-direction: row;
    justify-content: center;
    line-height: 1.5;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }
}
</style>
